import {AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActionButtonControl, ButtonControl, UIArtefakt, UiInputControl} from '../../../../models/uiArtefakt';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UIAusrichtung} from '../../../../models/uiAusrichtung';
import {Observable} from 'rxjs';
import {map, take, tap} from 'rxjs/operators';
import {ThemeService} from '@lv1871/core';
import {EnumButtonAktionsTyp} from '../../../../models/enumButtonAktionsTyp';
import {EnumGruppeTechnischeSteuerung} from '../../../../models/enumGruppeTechnischeSteuerung';
import {ValidationService} from '../../../../services/validation.service';

export class ModalDialogButtonViewInput {
  public buttonComponent: string;
  public titel: string;
  public actionButton$: Observable<ActionButtonControl>;
  public modul$: Observable<UIArtefakt>;
}

@Component({
    selector: 'lv-modal-dialog-button-view',
    templateUrl: './modal-dialog-button-view.component.html',
    styleUrls: ['./modal-dialog-button-view.component.scss'],
    standalone: false
})

export class ModalDialogButtonViewComponent implements OnInit, AfterViewInit  {

  @ViewChild(NgForm, {static: true})
  private _ngForm;

  public uiArtefakt: ButtonControl;
  public actionButton$: Observable<ActionButtonControl>;
  public uiModul$: Observable<UIArtefakt>;
  public titel: string;
  public showFooter: boolean;
  public uiControlsRequestPending: boolean;
  public showSpinner: boolean;
  public uiAusrichtung: UIAusrichtung;
  public isPflichtfeld$: Observable<boolean>;

  constructor(public dialogRef: MatDialogRef<ModalDialogButtonViewComponent>,
              private _themeService: ThemeService,
              private _validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public data: ModalDialogButtonViewInput,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  ngAfterViewInit(): void {
    if(!!this.uiArtefakt?.IdentifikatorUuid) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    }
    if(!!this.uiArtefakt?.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public ngOnInit(): void {
    this.showFooter = this.data.buttonComponent === 'ModalDialogOhneButtons';
    this.uiModul$ = this.data.modul$;
    this.isPflichtfeld$ = this.uiModul$.pipe(
        map((data) =>
            data.UIArtefakt.filter(artefakt =>
                !!(artefakt as UiInputControl).PflichtfeldJN && !artefakt.WertEingabe
            ).length > 0
        )
    );
    this.titel = this.data.titel;
    this.actionButton$ = this.data.actionButton$;
    this._themeService.setApplicationTheme(
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'), null,
        'mdc-dialog__container'
    );
  }

  public closeDialog(): void {
    this.dialogRef.close(EnumButtonAktionsTyp.MODALDIALOG_ABBRECHEN);
  }

  weiterButtonClicked(): void {
    this.dialogRef.close(EnumButtonAktionsTyp.MODALDIALOG_SCHLIESSEN);
  }

  abbrechenButtonClicked(): void {
    this.dialogRef.close(EnumButtonAktionsTyp.MODALDIALOG_ABBRECHEN);
  }

  actionButtonClicked(buttonAktionsTyp: string): void {
    if (EnumButtonAktionsTyp.ELEKTRONISCHUNTERSCHREIBEN_MOEGLICH === buttonAktionsTyp ||
        EnumButtonAktionsTyp.ELEKTRONISCHUNTERSCHREIBEN_NICHT_MOEGLICH === buttonAktionsTyp) {
      this.uiModul$.pipe(
          take(1),
          tap(uiControl => {
            const isValid = this._validationService.validateGruppeTechnischeSteuerung(
                uiControl.UIArtefakt, EnumGruppeTechnischeSteuerung.ELEKTRONISCHE_UNTERSCHRIFT_VALIDIERUNG);
            if (isValid) {
              this.dialogRef.close(buttonAktionsTyp);
            }
          })).subscribe();
    } else {
      this.dialogRef.close(buttonAktionsTyp);
    }
  }
}
